<button
  [type]="type()"
  [disabled]="disabled() || loading()"
  [class]="
    'app-button app-button--' +
    (text() ? 'text' : variant()) +
    ' app-button--' +
    severity() +
    ' app-button--' +
    size() +
    (rounded() ? ' app-button--rounded' : '') +
    (fluid() ? ' app-button--fluid' : '') +
    ' ' +
    styleClass()
  "
>
  @if (loading()) {
    <span class="app-button__spinner" aria-hidden="true"></span>
  } @else if (icon()) {
    <i [class]="'app-button__icon app-icon app-icon-' + iconName()" aria-hidden="true"></i>
  }
  @if (label()) {
    <span class="app-button__label">{{ label() }}</span>
  }
</button>
